import { render } from "./SuccessLoginPage.vue?vue&type=template&id=488ee2ed"
import script from "./SuccessLoginPage.vue?vue&type=script&lang=js"
export * from "./SuccessLoginPage.vue?vue&type=script&lang=js"

import "./SuccessLoginPage.vue?vue&type=style&index=0&id=488ee2ed&lang=css"

import exportComponent from "/codebuild/output/src3621675308/src/competition/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__